var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 19.6875V2.8125C30 1.25918 28.5603 0 26.7857 0H6.42857C2.87812 0 0 2.51836 0 5.625V24.375C0 27.4816 2.87812 30 6.42857 30H27.8571C29.0404 30 30 29.1604 30 28.1777C30 27.491 29.5576 26.9168 28.9286 26.5898V21.8227C29.5848 21.2578 30 20.5195 30 19.6875ZM9.58259 7.5H22.4397C23.0893 7.5 23.5714 7.92188 23.5714 8.4375C23.5714 8.95312 23.0893 9.375 22.5 9.375H9.58259C9.05357 9.375 8.57143 8.95312 8.57143 8.4375C8.57143 7.92188 9.05357 7.5 9.58259 7.5ZM9.58259 11.25H22.4397C23.0893 11.25 23.5714 11.6719 23.5714 12.1875C23.5714 12.7031 23.0893 13.125 22.5 13.125H9.58259C9.05357 13.125 8.57143 12.7031 8.57143 12.1875C8.57143 11.6719 9.05357 11.25 9.58259 11.25ZM25.7143 26.25H6.42857C5.24531 26.25 4.28571 25.4104 4.28571 24.375C4.28571 23.3396 5.24531 22.5 6.42857 22.5H25.7143V26.25Z",
    fill: "url(#paint0_linear_78_52)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_78_52",
    x1: 31.4318,
    y1: 30,
    x2: -1.50917,
    y2: 29.5428,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B712"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455446,
    stopColor: "#02F781"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FFF00"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoc);
export default __webpack_public_path__ + "static/media/doc.1a80a28caacb83d97c0e96702d1340fd.svg";
export { ForwardRef as ReactComponent };